import { render, staticRenderFns } from "./CustomerInfo.view.vue?vue&type=template&id=f1c6af46&"
import script from "./CustomerInfo.view.vue?vue&type=script&lang=js&"
export * from "./CustomerInfo.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1c6af46')) {
      api.createRecord('f1c6af46', component.options)
    } else {
      api.reload('f1c6af46', component.options)
    }
    module.hot.accept("./CustomerInfo.view.vue?vue&type=template&id=f1c6af46&", function () {
      api.rerender('f1c6af46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/CustomerInfo.view.vue"
export default component.exports